<script setup lang="ts">
import SigninButton from "~/components/SigninButton.vue";
import Header from "~/components/EvangelistLanding/Header.vue";
import Footer from "~/components/EvangelistLanding/Footer.vue";
import Faq from "~/components/EvangelistLanding/Faq.vue";
const learnMoreModalVisible = ref(false);

onMounted(() => {
  trackEvent("page_landing_viewed", {
    trigger: "page_load",
    advertiser: "evangelist",
  });

  initGateway();
});

useHead({ bodyAttrs: { class: "body--evangelist-confetti" } });

definePageMeta({ layout: "blank" });
</script>

<template>
  <Modal
    v-if="learnMoreModalVisible"
    class="modal--content"
    @close="learnMoreModalVisible = false"
  >
    <ContentsHowDoesItWorksSlider />
    <div class="text-center mt-8">
      <button
        class="btn bg-purple-light hover:bg-black hover:text-white"
        @click="learnMoreModalVisible = false"
      >
        Done
      </button>
    </div>
  </Modal>

  <Header />
  <div class="container-1200 mt-8 lg:mt-20 lg:text-center font-semibold">
    <div
      class="text-3xl lg:text-6xl mb-6 lg:mb-14 lg:mx-auto"
      style="max-width: 700px"
    >
      Just post stuff about the things
      <span class="text-purple">you love</span>
      <span>.</span>
    </div>
    <div class="text-2xl lg:text-2xl mb-0 w-2/3 lg:w-full">
      And get paid while doing that.
    </div>
    <div class="my-8 lg:my-14">
      <SigninButton
        class="btn bg-purple-light text-black hover:text-white hover:bg-black"
        >Sign in via
        <IconsTweetIcon />
      </SigninButton>
    </div>
    <div class="text-xl lg:text-2xl mb-8 mt-0 lg:mt-20 pr-8 lg:pr-0 lg:w-full">
      <span
        >Evangelist helps ambassadors amplify product messages they believe
        in,</span
      >
      <span class="inline lg:block">
        using AI and blockchain for
        <span class="text-purple">fair compensation</span>
        and
        <span class="text-purple">greater impact</span>.
      </span>
    </div>
  </div>

  <div class="container-1200">
    <div class="border-t-2 border-gray-300 my-10 lg:my-28"></div>
    <div
      class="flex flex-wrap justify-start lg:justify-center items-center gap-6 lg:gap-12"
    >
      <div class="text-gray-500 text-lg lg:text-2xl w-full lg:w-auto">
        Pilot campaign partners
      </div>
      <img src="/logos/logo-marinade.svg" class="w-1/3 lg:w-auto" />
      <img src="/logos/logo-deriverse.svg" class="w-1/3 lg:w-auto" />
    </div>
  </div>

  <div class="container-1200 mt-14">
    <div class="p-6 py-8 lg:p-12 bg-white rounded-2xl">
      <div class="relative mx-auto" style="max-width: 600px">
        <ContentsHowDoesItWorksSlider>
          <template #top-part>
            <div class="text-black mb-2 lg:mb-8">
              How do Ambassadors get paid?
            </div>
          </template>
        </ContentsHowDoesItWorksSlider>
      </div>
    </div>
  </div>

  <Faq class="mt-10 md:mt-20" />
  <div class="my-8 px-6 max-w-4xl mx-auto lg:mb-14 lg:mt-20">
    <div class="flex flex-wrap justify-between items-center">
      <div class="font-semibold items-center text-xl pr-20 lg:pr-0">
        Interested in partnering with
        <span class="px-1 inline-block">
          <IconsEvangelistIcon class="inline w-5 h-5" />
        </span>
        Evangelist?
      </div>
      <div class="mt-4 md:mt-0">
        <a
          href="mailto:founders@evangelist.gg"
          data-analytics-click-id="button_contact_us_mailto_clicked"
          data-analytics-event-name="user_email_client_opened"
          class="btn bg-purple-light text-black hover:bg-black hover:text-white px-6"
          >Contact Us</a
        >
      </div>
    </div>
  </div>

  <Footer />
</template>
